







import { Component, Vue } from 'vue-property-decorator';
import PanelWebhookEvent from '@/app/shared/components/panels/webhook-event.vue';
@Component({ components: { PanelWebhookEvent } })
export default class TabItemWebhookEventComponent extends Vue {}
